export const debounce = (func, wait) => {
    let timeout
    return function (...args) {
        const context = this
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(context, args), wait)
    }
}

export const getCookie = (name) => {
    var nameEQ = name + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
}

export const getTargeterCookie = () => {
    return JSON.parse(decodeURIComponent(getCookie(TARGETER4_COOKIE_NAME)))
}

export const fetchData = (url, data = {}, responseType = 'json') => {
    const query_string = new URLSearchParams(data).toString()
    const fetch_url = url + (query_string ? (url.includes('?') ? '&' : '?') + query_string : '')

    return fetch(fetch_url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((response) => {
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`)
        }
        return responseType === 'json' ? response.json() : response.text()
    })
}
